// ═══════════════════════════════════════════════════════════════════
//  CourrielEntete.js
//  En-tête : titre, compteurs et boutons d'action — extrait de Courriel
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";
import { LIBELLES_DOSSIERS } from "./constantes";
import { btnStyle } from "./utils";

export function CourrielEntete({ charger, chargerDossiers, chargerStats, dossier, liste, setRedaction, setSignatureOuverte }) {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
    <div>
      <div style={{ color: THEME.text, fontSize: 22, fontWeight: 800 }}>📧 Courriel</div>
      <div style={{ color: THEME.textMuted, fontSize: 13, marginTop: 2 }}>
        Boîte staff · {LIBELLES_DOSSIERS[dossier]} · {liste ? `${liste.total} message${liste.total > 1 ? "s" : ""}` : "chargement…"}
        {liste?.unread > 0 && <b style={{ color: THEME.accent }}> · {liste.unread} non lu{liste.unread > 1 ? "s" : ""}</b>}
      </div>
    </div>
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
      <button onClick={() => setSignatureOuverte(true)} style={btnStyle()}>✍ Ma signature</button>
      <button onClick={() => { charger(); chargerStats(); chargerDossiers(); }} style={btnStyle()}>⟳ Actualiser</button>
      <button onClick={() => setRedaction({ to: "", subject: "", body: "" })} style={btnStyle(true)}>✎ Rédiger</button>
    </div>
  </div>
  );
}
